<div class="drawer-content-screen">
  <div class="drawer-content-screen__title">{{ 'filters' | translate }}</div>
  <div class="drawer-content-screen__body">
    <div class="pr-2">
      <app-email-search-tag-input
        [mailAccountId]="mailAccountId"
        [tagType]="tagType"
        [selectedTags]="selectedFullTags" />
    </div>
  </div>
  <div class="flex-none py-2">
    <div class="flex justify-between gap-2">
      <button mat-flat-button type="button" (click)="reset()">
        {{ 'resetFilters' | translate }}
      </button>
      <button mat-flat-button color="primary" type="button" (click)="search()">
        {{ 'search' | translate }}
      </button>
    </div>
  </div>
</div>
